export enum WEBPAGE {
  TERMS_AND_CONDITIONS = "https://landing.sigmagames.fun/terms/",
  PRIVACY_POLICY = "https://landing.sigmagames.fun/privacy/",
  TEST_FLIGHT_JOIN = "https://testflight.apple.com/join/Q9ZhVekc",
  TEST_FLIGHT_INSTALL = "https://apps.apple.com/us/app/testflight/id899247664?mt=8",
  PALM_STORE_HYPER_PAGE = "https://m.palmplaystore.com/app/soft_detail?itemID=s_17f05e82d20e4f29a45be03bf4b5ffd2",
  AMAZON_STORE_HYPER_PAGE = "https://www.amazon.com/gp/product/B0CZV67TNV",
  GALAXY_STORE = "https://galaxystore.samsung.com/games",
  DOWNLOAD_HYPER_QRCODE_LINK = "https://hypergame.onelink.me/4tib/dw8iofia",
  SIGMA_LANDING_PAGE = "https://landing.sigmagames.fun/",
  FACEBOOK = "https://facebook.com",
  X = "https://x.com",
  APP_STORE_HYPER_PAGE = "https://apps.apple.com/ng/app/hyper-play-casual-cash-games/id1631502021",
}

export enum VIDEO {
  HOW_TO_INSTALL_HYPER = "https://www.youtube.com/embed/xSZXx5jIFak?loop=1&fs=0&playsinline=0&controls=0&autoplay=1&playlist=xSZXx5jIFak",
  HOW_TO_INSTALL_HYPER_ON_TESTFLIGHT = "https://www.youtube.com/embed/Z7b_mXILKNk?loop=1&fs=0&playsinline=0&autoplay=1&playlist=Z7b_mXILKNk",
}

export enum SOCIAL {
  WHATSAPP = "https://chat.whatsapp.com/F0vmrfHNfDxGUGYh087VHM",
  X = "https://x.com/metaversemagna",
  TELEGRAM = "https://t.me/+L11t6Snlha9lYTBk",
  TIKTOK = "https://www.tiktok.com/@sigmagamingapp",
  INSTAGRAM = "https://www.instagram.com/metaversemagna/",
}

export const POST_TO_X_LINK = "https://x.com/intent/tweet";
